/* eslint-disable */
export enum LoginType {
	Facebook = "facebook",
	Scopely = "scopely",
	Auto = "auto"
}
/* eslint-enable */
